import { func, object, bool, number } from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { Input } from '@eika/input';
import Textarea from './textarea';

const RrRelationsUsa = ({
    question,
    getLabel,
    getHandleChange,
    errors,
    ekstratekster,
    getHelpBody,
    index,
    hasInvalidValue,
}) => {
    return (
        <>
            <div
                className={classNames(
                    'form-group',
                    { 'input-error error': hasInvalidValue },
                    'skjema-input-field-wrap-small skjema-input-field-wrap'
                )}
            >
                <label htmlFor={`${question.rrId}_skatterelasjonUsaTin`} className="control-label input-label">
                    {getLabel(ekstratekster, 'rr_fatcaTIN')}
                </label>
                <Input
                    onChange={getHandleChange('skatterelasjonUsaTin')}
                    name={`skatterelasjonUsaTin-${question.rrId}`}
                    className="form-control"
                    placeholder="XXX-XX-XXXX"
                    type="tel"
                    options={{ blocks: [3, 2, 4], delimiters: ['-'] }}
                    value={question.skatterelasjonUsaTin || ''}
                    id={`${question.rrId}_skatterelasjonUsaTin`}
                />
                {errors.includes('skatterelasjonUsaTin') ? (
                    <div className="input-error-message">
                        <i className="ikon-utropstegn-24 input-error-icon" aria-hidden="true" />
                        {getLabel(ekstratekster, 'rr_fatcaTIN_instruks')}
                    </div>
                ) : null}
            </div>

            <div
                className={classNames(
                    { 'has-error error': errors.includes('skatterelasjonUsaTinMangler') },
                    'skjema-input-field-wrap-small skjema-input-field-wrap'
                )}
            >
                <Textarea
                    className="rr-skatterelasjonUsaTinMangler"
                    label={getLabel(ekstratekster, 'rr_fatcaIkkeTIN')}
                    id={question.rrId}
                    name={`skatterelasjonUsaTinMangler-${index}`}
                    onChange={getHandleChange('skatterelasjonUsaTinMangler')}
                    value={question.skatterelasjonUsaTinMangler || ''}
                    errorText={
                        errors.includes('skatterelasjonUsaTinMangler')
                            ? getLabel(ekstratekster, 'rr_fatcaIkkeTIN_instruks')
                            : null
                    }
                    modalHelpHeader={ekstratekster.rr_fatcaIkkeTIN_infotittel}
                    modalHelpBody={getHelpBody(ekstratekster, 'rr_fatcaIkkeTIN_info')}
                />
            </div>
        </>
    );
};

RrRelationsUsa.propTypes = {
    question: object.isRequired,
    getLabel: func.isRequired,
    getHandleChange: func.isRequired,
    errors: object.isRequired,
    ekstratekster: object.isRequired,
    getHelpBody: func.isRequired,
    index: number.isRequired,
    hasInvalidValue: bool.isRequired,
};

export default React.memo(RrRelationsUsa);
